import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setSidebarResponsive } from "../redux/actions/ui";
import { CCreateElement, CSidebar, CSidebarNavItem } from "@coreui/react";
import { Icon, Popup } from "semantic-ui-react";
import { importOpenSidebar } from "../redux/actions/openSidebar";
import { Roles } from 'src/utils/roles'

import "./CompanyList/CompanyList.scss";
import navigation from "./_nav";
import { PLANS_SMARTCFO, Plans } from "src/utils/plans";
import { useContext } from "react";
import { CompanyContext, UserContext } from "src/context";
import { openSidebarReducer } from "src/redux/reducers/openSidebarReducer";

const Sidebar = (props) => {
  const dispatch = useDispatch();
  const { sidebarShow } = useSelector((state) => state.ui);
  const { openSidebar } = useSelector((state) => state.openSidebar);
  const { selectedCompany } = useContext(CompanyContext)

  useEffect(() => {
    if (openSidebar.show) {
      props.setMaximized(false);
    }
  }, [openSidebar]);

  const show = sidebarShow;
  const closeSideBar = () => {
    if (show === "responsive") {
      props.setMaximized(!props.maximized);
      dispatch(importOpenSidebar({ show: false }));
    }
  };

  const user = useContext(UserContext)

  const country = process.env.REACT_APP_COUNTRY

  const holdingCompanies = [
    '6760156cac2d65001cb6256b',
    '678fd7e47f10bc001df0f5be',
    '678ff012ce119d001c920368',
    '678ff0752ebe32001bc5cc9d',
    '678ff0d99c76ff001c1db195',
    '678ff113ce119d001c92a0b9'
  ]

  const NavItems = navigation.filter(f => {

    if (f.isHolding == true) {
      return holdingCompanies.includes(selectedCompany?.id)
      // if (holdingCompanies.includes(selectedCompany?.id)) return false
    }

    if (['/cobranza'].includes(f.to)) {
      if (country === 'COL') return false
      if (['64f783c82f1f8f001b570461'].includes(selectedCompany?.id)) return false
    }

    if (['/cuadratura'].includes(f.to)) {
      if (selectedCompany?.id !== '677d45356d129a001c2d0cbe') return false  //SOLO PARA CLASSPASS
    }

    if (['/eoaf'].includes(f.to)) {
      if (!['66bb9b816167d8001b2191de', '66ba8b77413fa3001b32adc8'].includes(selectedCompany?.id)) return false;
    }

    if (['/eerr'].includes(f.to)) {
      if ([
        '64a617632dd7b8001be80dd9', // ACTIVE IT
        '64a6182602d151001ccc3906', // ACTIVE IT COMERCIALIZADORA
      ].some(p => selectedCompany?.id == (p))) return false
      if (['64f783c82f1f8f001b570461'].includes(selectedCompany?.id)) return false
    }

    if (['/cobranza'].includes(f.to)) {
      if (PLANS_SMARTCFO.some(p => selectedCompany?.plan?.includes(p))) return false
    }

    // if (['/f-29'].includes(f.to)) {
    //   if (!['6021360b375070001aaaceeb', '5ec69e3858a05609422b1a5c', '5ec69e3858a05609422b1a3f'].includes(user?.id)) return false
    // }

    if (['/conciliacion'].includes(f.to)) {
      if (selectedCompany && selectedCompany?.plan
        && (selectedCompany?.plan.includes(Plans.smartcfo) || selectedCompany?.plan.includes(Plans.smartcfopro))
        && selectedCompany?.plan.length == 1) return false
    }

    if (['/eerr'].includes(f.to)) {
      if (selectedCompany && selectedCompany?.plan
        && (selectedCompany?.plan.includes(Plans.smartcfo))
        && selectedCompany?.plan.length == 1) return false
      if (['64f783c82f1f8f001b570461'].includes(selectedCompany?.id)) return false

    }

    if (['/reportes'].includes(f.to)) {
      if (selectedCompany && selectedCompany?.plan
        && (selectedCompany?.plan.includes(Plans.smartcfo) || selectedCompany?.plan.includes(Plans.smartcfofull) || selectedCompany?.plan.includes(Plans.smartcfopro))
      ) return true
      if (['64f783c82f1f8f001b570461'].includes(selectedCompany?.id)) return false
      return false
    }

    if (['/reportes_dj'].includes(f.to)) {
      if (selectedCompany && selectedCompany?.plan
        && (selectedCompany?.plan.includes(Plans.smartcfo) || selectedCompany?.plan.includes(Plans.smartcfofull) || selectedCompany?.plan.includes(Plans.smartcfopro))
      ) return true
      if (['64f783c82f1f8f001b570461'].includes(selectedCompany?.id)) return false
      return false
    }

    if (['/pago_proveedores'].includes(f.to)) {
      if (['64f783c82f1f8f001b570461'].includes(selectedCompany?.id)) return false
    }

    if (['/f-29'].includes(f.to)) {
      if (['64f783c82f1f8f001b570461'].includes(selectedCompany?.id)) return false
    }

    if (selectedCompany && selectedCompany?.plan && selectedCompany.plan.includes('inicia')) {
      if (['/creditos', '/pago_proveedores', '/reportes', '/reportes_dj', '/eerr'].includes(f.to)) return false
    }

    if (selectedCompany && selectedCompany?.plan && selectedCompany.plan.includes('despega')) {
      if (['/creditos', '/pago_proveedores', '/reportes', '/reportes_dj', '/eerr'].includes(f.to)) return false
    }

    return true
  })
  const handleNavItemClick = () => {
    dispatch(importOpenSidebar({ show: false }));
  };

  return (
    <CSidebar
      className={`${props.maximized && show === "responsive" ? "sidebarMaximized " : ""
        } c-sidebar-minimized marginFromTopBar`}
      id="sidebar_pepper"
      show={show}
      onShowChange={(val) => dispatch(setSidebarResponsive(val))}

    >
      <div className="">
        <div className="sidebar-account px-2 my-3"></div>
        <div
          onClick={handleNavItemClick}
        >
          {show === "responsive" && (
            <div className="containerOpenNav">
              <Icon
                name={`${props.maximized ? "outdent" : "indent"}`}
                className="containerOpenNav__toggleOpenNavbar"
                size="big"
                onClick={closeSideBar}
              />
            </div>
          )}
          <CCreateElement
            items={NavItems}
            components={{
              CSidebarNavItem,
            }}

          />
        </div>
      </div>
    </CSidebar>
  );
};

export default React.memo(Sidebar);
